(function () {
    "use strict";

    angular.module("app").controller("InstallationScreeningZonesController", InstallationScreeningZonesController);

    InstallationScreeningZonesController.$inject = ["controllerDecorator", "installationRequest", "arrayUtilities"];
    function InstallationScreeningZonesController(controllerDecorator, installationRequest, arrayUtilities) {
        const vm = this;

        const context = {
            Backup: null,
        };

        controllerDecorator.Decorate(vm, ["dialog"]);

        const physicalInstallationZoneType = Object.freeze({
            Administrative: 0,
            Secured: 1,
        });
        
        vm.Init = init;

        vm.AllowedLevelsForSecuredZone = [];

        vm.Add = {
            SecuredZone: addSecuredZone,
            AdministrativeZone: addAdministrativeZone,
        };
        vm.Delete = deleteZone;

        vm.Save = save;
        vm.DiscardChanges = discardChanges;

        vm.PurposeChecked = purposeChecked;

        function init(request, allLevels) {
            vm.request = request;

            const confidentialLevel = 10;

            vm.AllowedLevelsForSecuredZone = allLevels
                .map(c => { return { Level: Number.parseInt(c.Key), Label: c.Value }; })
                .filter(item => item.Level >= confidentialLevel && item.Level <= request.Level);

            vm.ZoneTree = prepareZoneTree(vm.request.Zones);
            backupZones();
        }

        function prepareZoneTree(zones) {
            const zoneTree = zones.filter(z => z.Type === physicalInstallationZoneType.Administrative);

            for (const zone of zoneTree) {
                zone.Children = zones.filter(z => z.ParentId === zone.PublicId);
            }

            return zoneTree;
        }

        function backupZones() {
            context.Backup = vm.request.Zones.map(cloneObject);
        }

        function addSecuredZone(parentId) {
            const newZone = ZoneConstructor(physicalInstallationZoneType.Secured, parentId);

            const parent = vm.ZoneTree.find(z => z.PublicId === parentId);
            parent.Children.push(newZone);
        }

        function addAdministrativeZone(form) {
            const newZone = ZoneConstructor(physicalInstallationZoneType.Administrative, null);

            vm.ZoneTree.push(newZone);

            form.$setValidity("Zones", vm.ZoneTree.length > 0);
        }

        function deleteZone(zone, form) {

            if (zone.Type === physicalInstallationZoneType.Administrative) {
                arrayUtilities.RemoveItem(vm.ZoneTree, zone);
            }
            else {
                const parent = vm.ZoneTree.find(z => z.PublicId === zone.ParentId);
                arrayUtilities.RemoveItem(parent.Children, zone);
            }

            form.$setValidity("Zones", vm.ZoneTree.length > 0);
        }

        function save(form) {

            const securedZones = vm.ZoneTree.flatMap(z => z.Children);
            const allZones = [...vm.ZoneTree, ...securedZones];

            vm.SetLoadingState(true);
            installationRequest.SaveZones(
                { RequestId: vm.request.PublicId, Zones: allZones },
                r => updateRequestZones(r.data, form),
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function discardChanges(form) {
            vm.Dialog.Confirm(vm.getTranslation("DiscardChanges_AreYouSure_Message"))
                .then(() => updateRequestZones([...context.Backup], form), angular.noop);
        }

        function updateRequestZones(zones, form) {
            vm.request.Zones = zones;
            vm.ZoneTree = prepareZoneTree(zones);

            if (form)
                form.$setPristine();

            backupZones();
        }

        function purposeChecked(zone, form) {
            form.$setValidity("Purposes", zone.Purposes.length > 0);
        }

        function ZoneConstructor(type, parentId) {
            return {
                Type: type,
                // We MUST generate a Guid to enable linking a secured zone to a newly created administrative zone.
                // Otherwise we have to Save zones separately when completed.
                PublicId: vm.guid.new(),
                ParentId: parentId,
                // Ensure the list of Purposes is initialized, otherwise selecting/deselecting will not work
                Purposes: [],
                Children: [],
            };
        }

        function cloneObject(object) {
            return { ...object };
        }
    }
})();